import { render, staticRenderFns } from "./tree-mobile.vue?vue&type=template&id=38843baf"
import script from "./tree-mobile.vue?vue&type=script&lang=js"
export * from "./tree-mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./tree-mobile.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports